import { render, staticRenderFns } from "./WorkCompletedEntry.vue?vue&type=template&id=58af038e&scoped=true"
import script from "./WorkCompletedEntry.vue?vue&type=script&lang=js"
export * from "./WorkCompletedEntry.vue?vue&type=script&lang=js"
import style0 from "./WorkCompletedEntry.vue?vue&type=style&index=0&id=58af038e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af038e",
  null
  
)

export default component.exports